import { fork, put, select, takeLatest } from 'redux-saga/effects';

import { BUSINESS_ACCOUNTS_STEP_ID } from '@src/containers/Routes/helper/stepActiveIds.helper';

import * as offersHelpers from './offersHelpers.ts';
import { nextStep } from '../../../actions';
import { redirectToURL } from '../../../helpers/redirection';
import { putAPI } from '../../../lendingAPI/lendingAPIHelpers';
import { saveCustomerState } from '../../AutomatedLendingDecision/AutomatedLendingDecisionUtils';
import {
    ACCOUNT_PAGES_DECLINED_URL,
    ACCOUNT_PAGES_URL
} from '../../LoanDecision/LoanDecision.sagas';
import { CLOSE_MODAL, OPEN_MODAL } from '../../Modals/Modals.actions';
import { SELECT_OFFER } from '../Offers.actions.js';

export default [fork(selectOffer)];

export function* handleNewOffers() {
    yield* openFetchOffersModal();

    yield* saveCustomerState();

    const application_id = yield select(
        ({ lendingAPI }) => lendingAPI.application.data.application_id
    );

    const getOffersSuccess = yield putAPI({
        type: 'api/GET_OFFERS',
        body: { application_id }
    });

    const offersResponse = getOffersSuccess.payload;

    const isPartnerCustomer = yield select((state) =>
        offersHelpers.isPartnerCustomer(state)
    );

    yield put({
        type: 'OFFERS_PAGE_READY',
        payload: { offersResponse, isPartnerCustomer }
    });

    const { offer_creation_status, offers } = offersResponse;

    if (
        offer_creation_status === 'declined' ||
        offer_creation_status === 'deferred'
    ) {
        yield* saveCustomerState('myAccount');
        return redirectToURL(ACCOUNT_PAGES_DECLINED_URL);
    }

    if (offers.length === 1 && offers[0].offer_type === 'confirmed') {
        yield* saveCustomerState('myAccount');
        return redirectToURL(ACCOUNT_PAGES_URL);
    }

    yield* closeFetchOffersModal();

    yield put(nextStep('productOffers'));
}

export function* selectOffer() {
    yield takeLatest(
        SELECT_OFFER,
        function* ({ payload: { offer_id, offer_type, product_type } }) {
            try {
                yield putAPI({
                    type: 'api/POST_SELECT_OFFER',
                    body: { offer_id }
                });

                if (
                    offer_type === 'confirmed' ||
                    product_type === 'lightningBlocked' ||
                    product_type === 'flexi24AutoBlocked'
                ) {
                    yield* saveCustomerState('myAccount');

                    return redirectToURL(ACCOUNT_PAGES_URL);
                }

                yield putAPI({
                    type: 'api/GET_APPLICATION'
                });

                yield put(nextStep(BUSINESS_ACCOUNTS_STEP_ID));
            } catch (error) {
                console.log(error);
            }
        }
    );
}

function* openFetchOffersModal() {
    yield put({ type: OPEN_MODAL, modalId: 'fetchOffers' });
}

function* closeFetchOffersModal() {
    yield put({ type: CLOSE_MODAL });
}
